// test372
(372 && 0);
